<ui-card>
    <app-segment-header title="time-off-v3.policyComponents.accrualSettings.header"> </app-segment-header>
    <h4>{{ 'time-off-v3.policyComponents.accrualSettings.policySubtitle' | translate }}</h4>

    <mat-radio-group
        class="vertical"
        name="isPolicyUnlimited"
        [(ngModel)]="timeOffPolicy.isUnlimited"
        (ngModelChange)="resetTimeOffPolicyAccrualValues()"
    >
        <mat-radio-button [value]="false"
            >{{ 'time-off-v3.policyComponents.accrualSettings.setUpAnAccrualScheduleForThisPolicy' | translate }}
            <small
                ><p class="helper-text">
                    {{ 'time-off-v3.policyComponents.accrualSettings.timeOffAccruesHelperText' | translate }}
                </p>
            </small>
        </mat-radio-button>

        <mat-radio-button class="margin-top-1" [value]="true">
            {{ 'time-off-v3.policyComponents.accrualSettings.thisPolicyIsUnlimited' | translate }}
            <small
                ><p class="helper-text">
                    {{ 'time-off-v3.policyComponents.accrualSettings.assignedHelperText' | translate }}
                </p>
            </small>
        </mat-radio-button>
    </mat-radio-group>
</ui-card>
